// src/pages/CollectionOrders/components/edit/OrderCollectorsTab.tsx
import React, { useState } from 'react';
import DefaultModal from '../../../../components/default/DefaultModal';
import ButtonCreate from '../../../../components/buttons/ButtonCreate';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import useCollectionOrderService from '../../../../app/services/hooks/useCollectionOrderService';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { CollectionOrderCollectorRow } from '../../../../app/models/CollectionOrder';
import SelectTwo from '../../../../components/SelectTwo';

type SelectOpt = { id: number | string; name: string };

interface Props {
  orderId: number;
  rows: CollectionOrderCollectorRow[];
  onChanged: () => void;
  readOnly?: boolean;
}

const OrderCollectorsTab = ({ orderId, rows, onChanged, readOnly = false }: Props) => {
  const { getOrderCollectors, createOrderCollectorOptions, storeOrderCollector, deleteOrderCollector,
          fetchingStoreOrderCollector } = useCollectionOrderService();

  const [showCreate, setShowCreate] = useState(false);
  const [available, setAvailable] = useState<SelectOpt[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [isLead, setIsLead] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = () => {
    getOrderCollectors(orderId, {
      onSuccess: onChanged,
      onError: onChanged
    });
  };

  const openCreate = () => {
    createOrderCollectorOptions(orderId, {
      onSuccess: (resp: ServiceResponse) => {
        setAvailable(resp.data.available_collectors || []);
        setShowCreate(true);
      }
    });
  };

  const doStore = () => {
    if (!selectedUserId) { setError('Debe seleccionar un usuario'); return; }
    storeOrderCollector(orderId, { user_id: selectedUserId, is_lead: isLead }, {
      onSuccess: () => { setShowCreate(false); setSelectedUserId(null); setIsLead(false); reload(); },
      onError: (resp: ServiceResponse) => setError(resp.message)
    });
  };

  return (
    <>
      {!readOnly && (
        <div className="d-flex justify-content-end mb-2">
          <ButtonCreate title="Agregar usuario" callbackCreate={openCreate} />
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-sm table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Usuario</th>
              <th>Líder</th>
              {!readOnly && <th style={{width: 100}}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.user_id}</td>
                <td>{r.user}</td>
                <td>{r.is_lead ? 'Sí' : 'No'}</td>
                {!readOnly && (
                  <td>
                    <ButtonTableAction
                    title="Quitar"
                    classIcon="mdi mdi-delete"
                    colorIcon="text-danger"
                    callbackFunction={() =>
                      deleteOrderCollector(r.id, { onSuccess: reload, onError: reload })
                    }
                  />
                  </td>
                )}
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={4} className="text-center text-muted">Sin usuarios asignados</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {!readOnly && showCreate && (
        <DefaultModal
          show={showCreate}
          handleClose={() => setShowCreate(false)}
          title="Agregar usuario a la orden"
          showFooter={false}
          backdrop={true}
        >
          <div className="mb-3">
            <label className="col-form-label">Usuario</label>
            <SelectTwo
              name="user_id"
              id="user_id"
              inputValue={selectedUserId}
              options={(available || []).map(a => ({ value: a.id, label: a.name }))}
              onChange={(v: any) => { setSelectedUserId(v?.value ?? null); setError(null); }}
              placeholder="Seleccione usuario"
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" id="is_lead"
                   checked={isLead} onChange={(e) => setIsLead(e.target.checked)} />
            <label className="form-check-label" htmlFor="is_lead">Marcar como líder</label>
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-secondary me-2" onClick={() => setShowCreate(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={doStore} disabled={!!fetchingStoreOrderCollector}>Agregar</button>
          </div>
        </DefaultModal>
      )}
    </>
  );
};

export default OrderCollectorsTab;
